/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Page_Book_LeadInputs */

const en_price_page_book_lead = /** @type {(inputs: Price_Page_Book_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Booking and payment in one step.`)
};

const pl_price_page_book_lead = /** @type {(inputs: Price_Page_Book_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezerwacja i płatność w jednym kroku.`)
};

/**
* | output |
* | --- |
* | "Booking and payment in one step." |
*
* @param {Price_Page_Book_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const price_page_book_lead = /** @type {((inputs?: Price_Page_Book_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Page_Book_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_price_page_book_lead(inputs)
	return en_price_page_book_lead(inputs)
});